import { render, staticRenderFns } from "./BillingPortal.vue?vue&type=template&id=d28fda34&scoped=true&"
import script from "./BillingPortal.vue?vue&type=script&lang=js&"
export * from "./BillingPortal.vue?vue&type=script&lang=js&"
import style0 from "./BillingPortal.vue?vue&type=style&index=0&id=d28fda34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28fda34",
  null
  
)

export default component.exports